import React from 'react'
import { TypeAnimation } from "react-type-animation";

function TopHeaderComponent() {
  return (
    <div>
        <div className='TopHeader-Component-bg'>
            <div className='TopHeader-Component-bg-shadow'>

            <div className='top-header-component-main-content'>
        <div className="landing-header-heading-1">
              <TypeAnimation
                sequence={[
                  "lighten the dark skin",
                  2500,
                  "Women Waxing At Home",
                  2500,
                  "Facial & Cleanup At Home",
                  2500,
                  "Body Polishing At Home",
                  2500,
                  "Body Scrubbing At Home",
                  2500,
                  "Manicure & Pedicure At Home",
                  2500,
                  "Party Makeup At Home",
                  2500,
                  "Bridal Makeup At Home",
                  2500,
                  "Pre-Bridal Grooming At Home",
                  2500,
                  "Wedding Packages At Home",
                  2500,
                  
                ]}
                speed={50}
                repeat={Infinity}
              />
            </div>

             <div ></div>

            <div className="landing-header-heading-1">in <div>Delhi-NCR</div></div>
    <div className="landing-header-heading-2">
            waxing services for Women at home
            </div>


                {/* <p> <span> Home  </span>  <b> <i class="fa-solid fa-chevron-right"></i> </b> <span>Salon for Women </span> </p> */}
         
          <p className="book-btn-of-glazma-landing-page"> 
                  <div > <a href="#services">Book Services Now </a> </div> 
              <div>  <a href="tel:+918527273020">Book by Call</a></div>
                </p>

            </div>

          
            </div>
        </div>
    </div>
  )
}

export default TopHeaderComponent